import { StoryblokComponent } from '@storyblok/react'
import { type FC } from 'react'
import { type SignUpStoryblok } from '~/types/generated'
import styles from './SignUpPage.module.scss'

interface SignUpPageProps {
  story: SignUpStoryblok;
}

export const SignUpPage: FC<SignUpPageProps> = ({ story }) => {
  const { title, introText: text, ...formProps } = story

  return (
    <div className="wrapper wrapper-bottom ">
      <main className={styles.grid}>
        <StoryblokComponent blok={{
          title,
          text,
          component: 'homepageHero'
        }}
        />
        <StoryblokComponent blok={{
          ...formProps,
          component: 'signupForm'
        }}
        />
      </main>
    </div>
  )
}
